module.exports = __webpack_public_path__ + "media/IntroductionExplore.5613fa7d.mp4";